import React from 'react';
import './cardrenungan.scss'; // Asumsikan Anda punya file styling

const RenunganCard = ({ 
    title, 
    penulis, 
    image, 
    content, // konten penuh, kita ambil ringkasannya
    onEdit, 
    onDelete 
}) => {
    
    // Ringkasan konten untuk tampilan card
    const summary = content.replace(/<[^>]*>?/gm, '').substring(0, 150) + '...';

    // Mendeteksi apakah ini mode Operator atau User biasa
    const isOperatorMode = onEdit && onDelete;
    
    return (
        <div className="renungan-card">
            {image && (
                <div className="card-image" style={{ backgroundImage: `url(${image})` }}>
                    {/*  */}
                </div>
            )}
            <div className="card-body">
                <h3 className="card-title">{title}</h3>
                <p className="card-author">Oleh: {penulis}</p>
                
                {/* Tampilkan Ringkasan Konten untuk card */}
                <p className="card-summary">{summary}</p>

                {isOperatorMode && (
                    <div className="card-actions">
                        {/* Tombol EDIT */}
                        <button 
                            className="btn-edit" 
                            onClick={(e) => {
                                // Mencegah aksi klik card (jika card juga punya onClick)
                                e.stopPropagation(); 
                                onEdit();
                            }}
                        >
                            ✏️ Edit
                        </button>
                        
                        {/* Tombol HAPUS */}
                        <button 
                            className="btn-delete" 
                            onClick={(e) => {
                                // Mencegah aksi klik card
                                e.stopPropagation(); 
                                onDelete();
                            }}
                        >
                            ❌ Hapus
                        </button>
                    </div>
                )}

                {/* Tombol untuk mode User (jika card juga berfungsi sebagai tombol detail) */}
                {!isOperatorMode && (
                    <button className="btn-read-more">Baca Selengkapnya</button>
                )}
            </div>
        </div>
    );
};

export default RenunganCard;